// vue-i18n config options
// @ts-ignore --- defineI18nConfig is auto-imported
export default {
  legacy: false,
  availableLocales: ['en', 'es', 'pt'],
  locale: "es",
  fallbackLocale: "es",
}